module.exports = __webpack_public_path__ + "static/media/warning_red_cluster.402f69da.svg";